// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ea-0";
export var actionModalContentContainer = "_ea-1";
export var createTagButton = "_ea-2";
export var footerContainer = "_ea-7";
export var fullWidthDivider = "_ea-3";
export var hasCreateTagButton = "_ea-4";
export var noCreateTagButton = "_ea-5";
export var tagsContainer = "_ea-6";
export var tagsModalContentContainer = "_ea-8";